import React                            from 'react';
import { pdf }                          from '@react-pdf/renderer';
import apis                             from 'common/apis';
import Log                              from 'common/log';
import utility                          from 'common/utility';
import Resume                           from 'pages/Pdf';

const log = Log ('ResumePdf', 'info');

const resumePdf = {};

resumePdf.getVideoThumbnail = async (studentData) => {
	let vurl = studentData.pr_video;
	if (!vurl) {
		return;
	}
	let vid = vurl.split ('/');
	vid = vid[vid.length - 1];

	let thumbnailUrl;
	try {
		thumbnailUrl = await apis.getVideoThumbnail (vid);
		log.info ({thumbnailUrl}, 'thumbnail get ok');
	}
	catch (err) {
		log.error ({err}, 'error getting video thumbnail');
		return;
	}
	let sizes = thumbnailUrl.data ? thumbnailUrl.data[0]?.sizes : thumbnailUrl.pictures?.sizes;
	return sizes?.[5]?.link;
};

resumePdf.getApplicantPhoto = async (applicantId) => {
	if (!applicantId) {
		return;
	}
	try {
		let result = await apis.getApplicantPhoto ({applicant : {applicant_id : applicantId}});
		return utility.getImgSrc (result.photograph);
	}
	catch (err) {
		log.error ({err}, 'error getting applicant photo');
		if (err.response && err.response.status === 401) {
			throw err;
		}
		return;
	}
};

/*
 * Builds the resume PDF blob for one applicant profile.
 * Photo and thumbnail are optional; a failure there still yields a PDF.
 * A 401 on the photo fetch is rethrown so the caller can redirect to login.
 */
resumePdf.createBlob = async (profile, isInterview) => {
	let [thumbnail, photo] = await Promise.all ([
		resumePdf.getVideoThumbnail (profile),
		resumePdf.getApplicantPhoto (profile.id),
	]);
	profile.thumbnail = thumbnail;
	if (photo) {
		profile.photograph = photo;
	}

	return pdf (<Resume studentData = {profile} isInterview = {isInterview}/>).toBlob ();
};

export default resumePdf;
